function SetRoles(roles) {
  return {
    type: 'SET_ROLES',
    roles: roles || {},
  };
}

export default SetRoles;
